export enum ProgramsSectionNavigatorEnum {
  ALL = 0,
  CLASSES = 1,
  INSTRUMENTS = 2,
  REPORTS = 3,
  MASTER_INSTRUMENTS = 4,
  EXPORTS = 5,
  PAPER_ASSESSMENTS = 6,
}
